import React from 'react'
import { Modal, ModalProps } from '@evrekadev/evreka-ui-components'
import { OverlayLoader } from 'containers/Overlay'

const ModalWithOverlay = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ModalProps>>(
  ({ children, ...props }, _ref) => {
    return (
      <Modal {...props}>
        <OverlayLoader isOpen={!!props.loading} />
        {children}
      </Modal>
    )
  },
)

export default ModalWithOverlay
